import { Typography } from '@weareopenr/component-library';
import styles from '../SyncReportModal.module.scss';

export const SyncModalHeaders = ({ stepCount, pageTitle }: { stepCount: number; pageTitle: string }) => {
  return (
    <>
      <Typography size="medium" weight="regular" className={styles['sync-steps']}>
        Step {stepCount + 1} of 3
      </Typography>

      <Typography size="xxlarge" weight="semi-bold">
        {pageTitle}
      </Typography>
      <Typography className={styles['subtitle']}>
        Review product updates before either accepting or rejecting the sync. No changes will be made until you have
        accepted the sync.
      </Typography>
    </>
  );
};
